module.exports = __webpack_public_path__ + "static/media/JP_AS_EYELASHES03.8409ac59.jpg";